import "../../styles/compo.scss";
import CenterTitleZ from "../atoms/CenterTitleZ";
import AllPopups from "./AllPopups";
import { forwardRef, useEffect } from "react";

const ContantWrapper = forwardRef(
  ({ title, icon, text, children, filterData }, ref) => {
    return (
      <div className="content-wrapper" ref={ref}>
        {children}
      </div>
    );
  }
);

export default ContantWrapper;
